module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/sketch-71e75e1a452af1482094206477766ef4.svg";